import { SET_SHOULD_FETCH_GM_PAYMENTS } from '../actions/types';

const initialState = { eligible: false, includeDealerFees: false, reason: '' };

export default function shouldFetchGMPayments(state = initialState, action) {
	if (action.payload !== undefined) {
		switch (action.type) {
			case SET_SHOULD_FETCH_GM_PAYMENTS:
				return action.payload;
			default:
		}
	}
	return state;
}
